// extracted by css-extract-rspack-plugin
export default {"triggerButton":"BaseBucketPickerPopover-module__triggerButton___NDbgO"};